module.exports = __webpack_public_path__ + "img/img_tab_3.981023b6.png";